import { useEffect } from "react";
import { type MessageDescriptor, useIntl } from "react-intl";

export function useDocumentTitle(title: string, id?: string): void {
  useEffect(() => {
    setDocumentTitle(title, id);
  }, [title, id]);
}

export function setDocumentTitle(title: string, id?: string): void {
  if (id) {
    title += ` ${id}`;
  }
  document.title = `${title} | ${WEBPACK_LABEL_TITLE}`;
}

export function useIntlDocumentTitle(intlId: MessageDescriptor["id"], id?: string): void {
  useDocumentTitle(useIntl().formatMessage({ id: intlId }), id);
}
